/* Vivapaw tema: pasiūlymas, krepšelio stalčius, lipnus mygtukas, pristatymo data, kontrolinis sąrašas. Be bibliotekų. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('vp-js');
  var CFG_EL = document.querySelector('[data-vp-cart-config]');
  var CFG = CFG_EL ? JSON.parse(CFG_EL.textContent) : {};
  var MONEY = CFG.moneyFormat || '{{amount_with_comma_separator}} €';

  function money(cents) {
    // Verbiva 2026-10-22: rinkos valiuta (USD/CAD/GBP/AUD/NZD/EUR) iš krepšelio, ne parduotuvės EUR formatas
    if (CFG.currency && window.Intl && Intl.NumberFormat) {
      try { return new Intl.NumberFormat(CFG.locale || 'en', { style: 'currency', currency: CFG.currency }).format(cents / 100); } catch (e) {}
    }
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return MONEY.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, dot);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Pristatymo data ---------- */
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); if (x.getDay() === 0) x.setDate(x.getDate() + 1); return x; }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); }
  $$('[data-vp-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 9, max = parseInt(el.getAttribute('data-max'), 10) || 17;
    var now = new Date();
    el.innerHTML = el.getAttribute('data-template').replace('{von}', '<b>' + fmt(addDays(now, min)) + '</b>').replace('{bis}', '<b>' + fmt(addDays(now, max)) + '</b>');
    el.hidden = false;
  });

  /* ---------- Pasiūlymo blokas ---------- */
  $$('[data-vp-offer]').forEach(function (offer) {
    var form = $('form', offer), btn = $('[data-vp-atc]', offer), sticky = $('[data-vp-sticky]', offer);
    function current() { return $('input[name="id"]:checked', offer); }
    /* Abo (Seal): kainos iš variant.selling_plan_allocations (procentai arba fiksuota kaina), intervalas pagal paketą (dėžučių × 2 mėn.) */
    var buy = $('[data-vp-buy]', offer), planInput = buy && $('[data-vp-plan]', buy), freq = buy && $('[data-vp-freq]', buy);
    var subBadge = buy && $('[data-vp-sub-badge]', buy), oncePrice = buy && $('[data-vp-once-price]', buy);
    function isSub() { var t = buy && $('[data-vp-sub-toggle]', buy); if (t) return t.checked; var r = buy && $('input[type=radio]:checked', buy); return !!(r && r.value === 'sub'); }
    function plans(c) { try { return JSON.parse(c.getAttribute('data-plans') || '[]'); } catch (e) { return []; } }
    function months(n) { var m = String(n).match(/(\d+)\s*(Monat|month)/i); return m ? parseInt(m[1], 10) : 0; }
    function fillPlans() {
      var c = current(); if (!freq || !c) return;
      var ps = plans(c), want = (parseInt(c.getAttribute('data-qty'), 10) || 1) * 2, pick = ps[0];
      ps.forEach(function (p) { if (months(p.n) === want) pick = p; });
      freq.innerHTML = '';
      ps.forEach(function (p) { var o = document.createElement('option'); o.value = p.id; o.textContent = p.n; if (p === pick) o.selected = true; freq.appendChild(o); });
      var wrap = freq.closest('.vpo-freq'); if (wrap) wrap.hidden = ps.length < 2;
    }
    function plan(c) { var ps = plans(c), id = freq ? freq.value : ''; for (var i = 0; i < ps.length; i++) if (String(ps[i].id) === String(id)) return ps[i]; return ps[0] || null; }
    function update() {
      var c = current(); if (!c) return;
      var base = parseInt(c.getAttribute('data-price'), 10), pl = buy ? plan(c) : null, p = isSub() ? pl : null;
      offer.classList.toggle('is-sub', !!p);
      if (planInput) { planInput.value = p ? p.id : ''; planInput.disabled = !p; }
      var cents = p ? p.p : base, price = money(cents);
      if (subBadge) { var diff = pl ? base - pl.p : 0; subBadge.hidden = !(diff > 0); if (diff > 0) subBadge.textContent = (subBadge.getAttribute('data-template') || '').replace('{betrag}', money(diff)); }
      if (oncePrice) oncePrice.textContent = c.getAttribute('data-price-formatted');
      if (btn && btn.getAttribute('data-label')) btn.querySelector('span').textContent = btn.getAttribute('data-label') + ' · ' + price;
      if (sticky) {
        $('[data-vp-sticky-title]', sticky).textContent = c.getAttribute('data-label');
        $('[data-vp-sticky-price]', sticky).textContent = price;
        var cmp = parseInt(c.getAttribute('data-compare'), 10) || 0;
        var strike = cmp > cents ? cmp : (p && base > cents ? base : 0);
        $('[data-vp-sticky-compare]', sticky).textContent = strike ? money(strike) : '';
        $('[data-vp-sticky-perk]', sticky).textContent = c.getAttribute('data-perk') || '';
        var img = $('[data-vp-sticky-img]', sticky), src = c.getAttribute('data-img');
        if (img && src) { if (img.getAttribute('src') !== src) img.src = src; img.hidden = false; }
        $$('[data-vp-pick]', sticky).forEach(function (b) {
          var on = b.getAttribute('data-vp-pick') === c.value; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
          var r = $('input[name="id"][value="' + b.getAttribute('data-vp-pick') + '"]', offer), sm = $('small', b);
          if (r && sm) { var sv = parseInt(r.getAttribute(p ? 'data-sub-save' : 'data-save'), 10) || 0; sm.textContent = sv ? '\u2212' + sv + '\u00a0%' : ''; }
        });
      }
    }
    var packs = sticky && $('[data-vp-sticky-packs]', sticky);
    if (packs) $$('input[name="id"]', offer).forEach(function (r) {
      if (r.disabled) return;
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('data-vp-pick', r.value);
      var sv = parseInt(r.getAttribute('data-save'), 10) || 0;
      b.innerHTML = '<b></b><small>' + (sv ? '\u2212' + sv + '\u00a0%' : '') + '</small>';
      b.querySelector('b').textContent = r.getAttribute('data-label');
      b.addEventListener('click', function () { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); });
      packs.appendChild(b);
    });
    $$('input[name="id"]', offer).forEach(function (r) { r.addEventListener('change', function () { fillPlans(); update(); }); });
    /* užrakinta dovana → pažymi reikiamą paketą ir nuslenka prie jo */
    $$('[data-vp-gift-from]', offer).forEach(function (g) {
      function go() {
        var from = parseInt(g.getAttribute('data-vp-gift-from'), 10) || 1, radios = $$('input[name="id"]', offer), cur = current();
        var ci = cur ? radios.indexOf(cur) + 1 : 0, r = radios[from - 1]; if (!r || r.disabled) return;
        if (ci < from) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        var tile = r.closest('.vpo-tile') || r; tile.classList.remove('is-flash'); void tile.offsetWidth; tile.classList.add('is-flash');
        tile.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      g.addEventListener('click', go);
      g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    if (buy) $$('input[type=radio], [data-vp-sub-toggle]', buy).forEach(function (r) { r.addEventListener('change', update); });
    if (freq) freq.addEventListener('change', update);
    fillPlans();
    update();

    if (form && offer.getAttribute('data-ajax') === 'true') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { if (btn) btn.removeAttribute('aria-busy'); VPCart.open(true); })
          .catch(function () { form.submit(); });
      });
    }

    if (sticky) {
      var target = $('[data-vp-atc]', offer) || offer, tick = false;
      function chk() { tick = false; sticky.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { var e = es[es.length - 1]; sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.bottom < 0); }).observe(target);
      } else {
        document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(chk); } }, { passive: true, capture: true });
        window.addEventListener('resize', chk); chk();
      }
      $('[data-vp-sticky-btn]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  });

  /* ---------- Kontrolinis sąrašas ---------- */
  $$('[data-vp-check]').forEach(function (box) {
    var res = $('[data-vp-check-result]', box), th = parseInt(box.getAttribute('data-threshold'), 10) || 2;
    function upd() {
      var n = $$('input[type=checkbox]:checked', box).length;
      $('[data-vp-check-count]', box).textContent = n;
      res.setAttribute('data-state', n === 0 ? 'none' : (n >= th ? 'high' : 'low'));
    }
    $$('input[type=checkbox]', box).forEach(function (i) { i.addEventListener('change', upd); });
    upd();
  });

  /* ---------- Atsiliepimų karuselė pirkimo bloke (duomenys — iš atsiliepimų sekcijos) ---------- */
  $$('[data-vp-revs]').forEach(function (box) {
    var src = document.querySelector(box.getAttribute('data-src')), track = $('[data-vp-revs-track]', box), dots = $('[data-vp-revs-dots]', box);
    if (!src || !track) return;
    var star = $('.vpo-gs i', box), posts = $$('.vp-post', src), max = 12, cards = [];
    posts.forEach(function (p) {
      var n = $$('.vp-post__stars svg', p).length; if (n < 4 || cards.length >= max) return;
      var tx = $('.vp-post__txt', p); if (!tx) return;
      var t = $('b', tx), title = t ? t.textContent.trim() : '', body = tx.textContent.trim();
      if (title && body.indexOf(title) === 0) body = body.slice(title.length).trim();
      var who = $('.vp-post__who b', p), meta = $('.vp-post__who span', p);
      var c = document.createElement('article'); c.className = 'vpo-rcard';
      var gs = document.createElement('span'); gs.className = 'vpo-gs'; gs.setAttribute('aria-label', n + '/5');
      for (var i = 0; i < 5; i++) { var el = star.cloneNode(true); if (i >= n) el.className = 'is-off'; gs.appendChild(el); }
      c.appendChild(gs);
      if (title) { var b = document.createElement('b'); b.textContent = title; c.appendChild(b); }
      var pp = document.createElement('p'); pp.textContent = body; c.appendChild(pp);
      var w = document.createElement('span'); w.className = 'vpo-rcard__who'; w.textContent = (who ? who.textContent.trim() : '') + (meta && meta.textContent.trim() ? ' · ' + meta.textContent.trim().split(' · ').slice(1).join(' · ') : '');
      w.textContent = w.textContent.replace(/ · $/, ''); c.appendChild(w);
      cards.push(c);
    });
    if (cards.length < 2) return;
    track.innerHTML = ''; cards.forEach(function (c) { track.appendChild(c); });
    var score = $('.vp-soc__score b', src), cnt = posts.length, sum = $('[data-vp-revs-sum]', box);
    var reviewSummary = src && src.getAttribute('data-vp-review-summary');
    var summaryCount = reviewSummary && reviewSummary.indexOf('·') !== -1 ? reviewSummary.substring(reviewSummary.indexOf('·') + 1).trim() : cnt + ' ' + (box.getAttribute('data-count-word') || '');
    if (sum && score) sum.innerHTML = '<b>' + score.textContent.trim() + '</b> · ' + summaryCount;
    if (dots) cards.forEach(function (c, i) { var d = document.createElement('i'); if (!i) d.className = 'is-on'; dots.appendChild(d); });
    function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 10 : 300; }
    function idx() { return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step()))); }
    var tk = false;
    track.addEventListener('scroll', function () { if (tk) return; tk = true; requestAnimationFrame(function () { tk = false; var k = idx(); $$('i', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); }); }, { passive: true });
    function go(dir) {
      var from = track.scrollLeft, to = Math.max(0, (idx() + dir) * step());
      track.scrollTo({ left: to, behavior: 'smooth' });
      setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 4 && Math.abs(to - from) > 4) track.scrollLeft = to; }, 450);
    }
    var pv = $('[data-vp-revs-prev]', box), nx = $('[data-vp-revs-next]', box);
    if (pv) pv.addEventListener('click', function () { go(-1); });
    if (nx) nx.addEventListener('click', function () { go(1); });
  });

  /* ---------- Atsiliepimai: „Mehr anzeigen“ ---------- */
  $$('[data-vp-more]').forEach(function (b) {
    b.addEventListener('click', function () { var w = document.getElementById(b.getAttribute('aria-controls')); if (w) w.classList.add('is-open'); b.remove(); });
  });

  /* ---------- Skirtukai ---------- */
  $$('[data-vp-tabs]').forEach(function (w) {
    w.addEventListener('click', function (e) {
      var b = e.target.closest('[data-t]'); if (!b) return;
      $$('[data-t]', w).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b); });
      $$('[data-p]', w).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-p') === b.getAttribute('data-t')); });
    });
  });

  /* ---------- Körperkarte: taškai ↔ punktai ---------- */
  $$('[data-vp-body]').forEach(function (w) {
    var n = $$('.vp-body__dot', w).length, cur = 1, timer = null, touched = false;
    function on(i) { cur = i; $$('[data-i]', w).forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-i') === String(i)); }); }
    function pick(e) { var t = e.target.closest('[data-i]'); if (!t) return; touched = true; clearInterval(timer); on(parseInt(t.getAttribute('data-i'), 10)); return t; }
    w.addEventListener('click', function (e) {
      var t = pick(e); if (!t || !t.classList.contains('vp-body__dot')) return;
      var pt = $('.vp-body__pt[data-i="' + t.getAttribute('data-i') + '"]', w); if (!pt) return;
      var r = pt.getBoundingClientRect(); if (r.top < 70 || r.bottom > window.innerHeight - 20) pt.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
    w.addEventListener('mouseover', function (e) { if (window.matchMedia('(hover:hover)').matches) pick(e); });
    if (n > 1 && 'IntersectionObserver' in window) new IntersectionObserver(function (es) {
      clearInterval(timer);
      if (es[0].isIntersecting && !touched) timer = setInterval(function () { on(cur % n + 1); }, 3200);
    }, { threshold: 0.4 }).observe(w);
  });

  /* ---------- Langai (dialog) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-vp-dialog-open]');
    if (o) { var d = document.getElementById(o.getAttribute('data-vp-dialog-open')); if (d && d.showModal) d.showModal(); return; }
    var c = e.target.closest && e.target.closest('[data-vp-dialog-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('vpo-dlg')) e.target.close();
  });

  /* ---------- Mobilus meniu ---------- */
  $$('.vp-burger').forEach(function (m) {
    m.addEventListener('toggle', function () { root.classList.toggle('vp-menu-open', m.open); });
    $$('a', m).forEach(function (a) { a.addEventListener('click', function () { m.open = false; }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.open) m.open = false; });
  });

  /* ---------- Atsiradimas slenkant + skaičiai ---------- */
  var reduce = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || /[?&]vbqa=1/.test(location.search);
  var REV = '.vp .vp-center, .vp-vet__media, .vp-vet__body, .vp-card, .vp-step, .vp-tl__step, .vp-fact, .vp-post, .vp-cmp2, .vp-dose, .vp-chk label, .vp-points li, .vp-split__media, .vp-guar, .vp-fin, .vp-faq details, .vp-story > *, .vp-pcard, .vp-reveal';
  function countUp(el) {
    var m = el.textContent.trim().match(/^(\D*)(\d+)(\D*)$/); if (!m) return;
    var to = parseInt(m[2], 10); if (to < 2 || to > 1000) return;
    var t0 = null; function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1100); el.textContent = m[1] + Math.round(to * (1 - Math.pow(1 - k, 3))) + m[3]; if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in'); io.unobserve(e.target);
        var b = e.target.matches('.vp-fact') && e.target.querySelector('b'); if (b) countUp(b);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$(REV).forEach(function (el) {
      if (el.closest('.vpo, .vpc, .vp-hdr')) return;
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.classList.add('vp-reveal'); el.style.transitionDelay = Math.min(sib, 5) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Krepšelio stalčius ---------- */
  var drawer = document.getElementById('vp-cart');
  /* Dovanų €0 sinchronizavimas be pikselių įvykių (2026-10-20): Shopify pikselių modulis stebi window.fetch ir
     /cart/update.js padidinimą siunčia kaip product_added_to_cart (Meta AddToCart) → 1 tikras paspaudimas = 4 AddToCart.
     Tuščio iframe fetch tas pats domenas ir slapukai, bet jo Shopify nestebi. Nepavykus — paprastas fetch. */
  function vpQuiet(url, opts) {
    try {
      if (!vpQuiet.f) {
        var ifr = document.createElement('iframe');
        ifr.style.display = 'none'; ifr.setAttribute('aria-hidden', 'true'); ifr.tabIndex = -1; ifr.title = 'vp';
        document.body.appendChild(ifr);
        vpQuiet.f = ifr.contentWindow.fetch.bind(ifr.contentWindow);
      }
      return vpQuiet.f(location.origin + url, opts);
    } catch (e) { return fetch(url, opts); }
  }
  var VPCart = {
    data: CFG,
    open: function (refresh) {
      if (!drawer) { window.location.href = '/cart'; return; }
      drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      root.classList.add('vp-lock');
      if (refresh !== false) VPCart.refresh();
    },
    close: function () {
      if (!drawer) return; drawer.classList.remove('is-open'); root.classList.remove('vp-lock');
      setTimeout(function () { drawer.hidden = true; }, 260);
    },
    refresh: function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(VPCart.render);
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(VPCart.render);
    },
    render: function (cart) {
      if (!drawer) return;
      var cfg = VPCart.data, list = $('[data-vp-cart-items]', drawer), tiers = cfg.tiers || {};
      VPCart._cart = cart;
      // Dovanos kasai (2026-10-20): €0 eilutės pagal didžiausią paketą krepšelyje; pridedam / nuimam patys, į skaičius neįeina
      var gifts = cfg.gifts || [], giftIds = {}, giftQty = 0, topTier = 0;
      gifts.forEach(function (g) { giftIds[String(g.id)] = g; });
      // vb-protect 2026-10-28: Shipping Protection eilutė — įjungta automatiškai, pirkėjas gali išjungti; į prekių skaičių neįeina
      var prot = cfg.protect && cfg.protect.v ? cfg.protect : null, protQty = 0, protKeys = [];
      if (prot) cart.items.forEach(function (it) { if (it.variant_id === prot.v) { protQty += it.quantity; protKeys.push(it.key); } });
      cart.items.forEach(function (it) { if (VPCart.vbIsMain && VPCart.vbIsMain(it)) return; var t = tiers[String(it.variant_id)] || 0; if (t > topTier) topTier = t; });
      if (VPCart.vbTier) topTier = Math.max(topTier, VPCart.vbTier(cart));
      if ((gifts.length || prot) && !VPCart._syncing) {
        var rm = {}, adds = [], need = false, JH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        gifts.forEach(function (g) {
          var want = topTier >= g.min, have = 0, auto = [];
          cart.items.forEach(function (it) { if (it.variant_id === g.id) { have += it.quantity; if (it.properties && it.properties._vb_gift) auto.push(it); } });
          if (want && have === 0) { adds.push({ id: g.id, quantity: 1, properties: { _vb_gift: '1' } }); need = true; }
          if (auto.length && (!want || have > auto.reduce(function (n, it) { return n + it.quantity; }, 0))) { auto.forEach(function (it) { rm[it.key] = 0; }); need = true; }
        });
        if (prot) {
          // tikros prekės = ne apsauga, ne €0 dovana, ne automatinė dovana, ne šiame žingsnyje nuimama eilutė
          var real = 0;
          cart.items.forEach(function (it) { if (it.requires_shipping === false || it.variant_id === prot.v || rm[it.key] === 0 || (it.properties && it.properties._vb_gift) || (giftIds[String(it.variant_id)] && it.final_line_price === 0)) return; real += it.quantity; });
          var wantP = real > 0 && (prot.auto === false ? protQty > 0 : !VPCart.protOff(cart));  /* auto išjungtas nustatymuose → tik pirkėjo įjungta */
          if (wantP && protQty === 0) { adds.push({ id: prot.v, quantity: 1 }); need = true; }
          else if ((!wantP && protQty > 0) || protQty > 1) { protKeys.forEach(function (k, i) { rm[k] = wantP && i === 0 ? 1 : 0; }); need = true; }
        }
        if (need) {
          VPCart._syncing = true;
          return (Object.keys(rm).length ? vpQuiet('/cart/update.js', { method: 'POST', headers: JH, body: JSON.stringify({ updates: rm }) }) : Promise.resolve({ ok: true }))
            .then(function (r) { if (!r.ok) throw r; return adds.length ? vpQuiet('/cart/add.js', { method: 'POST', headers: JH, body: JSON.stringify({ items: adds }) }) : { ok: true }; })
            .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function (c) { VPCart.render(c); }, function () { VPCart.render(cart); })
            .then(function () { VPCart._syncing = false; }, function () { VPCart._syncing = false; });
        }
      }
      cart.items.forEach(function (it) { if (giftIds[String(it.variant_id)] && it.final_line_price === 0) giftQty += it.quantity; });
      var count = cart.item_count - giftQty - protQty; cart.items.forEach(function (it) { if (it.requires_shipping === false && it.quantity > 1) count -= it.quantity - 1; }); /* vb-give: auka = 1 */
      $$('[data-vp-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
      drawer.classList.toggle('is-empty', count === 0);
      var maxTier = 0, html = '', giftHtml = '', wasTotal = 0;
      cart.items.forEach(function (it) {
        if (prot && it.variant_id === prot.v) { wasTotal += it.final_line_price; return; }
        if (giftIds[String(it.variant_id)] && it.final_line_price === 0) {
          giftHtml += '<li class="vpc-item vpc-item--gift"><img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '') + '" alt="" width="72" height="72" loading="lazy">' +
            '<div class="vpc-item__main"><b>' + it.product_title + '</b>' + (it.variant_title ? '<span>' + it.variant_title + '</span>' : '') + '</div>' +
            '<div class="vpc-item__price vpc-gift">' + ((cfg.t && cfg.t.gift) || 'Free') + '</div></li>';
          return;
        }
        if (VPCart.vbIsMain && VPCart.vbIsMain(it)) return;
        var t = tiers[String(it.variant_id)] || 0; if (t > maxTier) maxTier = t;
        var vimg = (cfg.images || {})[String(it.variant_id)];
        var cmpU = (cfg.compare || {})[String(it.variant_id)] || 0, wasLine = Math.max(it.original_line_price, cmpU * it.quantity); wasTotal += Math.max(wasLine, it.final_line_price);
        html += '<li class="vpc-item"><img src="' + (vimg || (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '')) + '" alt="" width="72" height="72" loading="lazy">' +
          '<div class="vpc-item__main"><b>' + it.product_title + '</b>' + (it.variant_title ? '<span>' + it.variant_title + '</span>' : '') +
          (it.selling_plan_allocation ? (VPCart.subLine ? VPCart.subLine(it.selling_plan_allocation.selling_plan.name, cfg) : '<span class="vpc-sub">' + it.selling_plan_allocation.selling_plan.name + '</span>') : '') +
          (it.requires_shipping === false ? '' : '<div class="vpc-qty"><button type="button" data-k="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="−">−</button><span>' + it.quantity + '</span><button type="button" data-k="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div>') + '</div>' + /* vb-give: auka be −/+ */
          '<div class="vpc-item__price">' + (wasLine > it.final_line_price ? '<s>' + money(wasLine) + '</s>' : '') + money(it.final_line_price) +
          '<button type="button" class="vpc-remove" data-k="' + it.key + '" data-q="0">' + cfg.t.remove + '</button></div></li>';
      });
      if (VPCart.vbRows) { var vbr = VPCart.vbRows(cart); html = vbr.html + html; wasTotal += vbr.was; if (vbr.tier > maxTier) maxTier = vbr.tier; }
      list.innerHTML = html + (cfg.giftsInDrawer ? giftHtml : '');
      $$('button[data-k]', list).forEach(function (b) { b.addEventListener('click', function () { VPCart.change(b.getAttribute('data-k'), parseInt(b.getAttribute('data-q'), 10)); }); });
      if (VPCart.vbBind) VPCart.vbBind(list);

      // Nemokamo siuntimo juosta
      var th = cfg.threshold, left, pct, label;
      // 'product': nemokamas siuntimas tik kai krepšelyje yra upsell produktas (Vital-Tropfen; kasoje — tarifas pagal svorį, 2026-10-20)
      if (cfg.mode === 'product') { var fps = (cfg.freeProducts && cfg.freeProducts.length) ? cfg.freeProducts : (cfg.freeProduct ? [cfg.freeProduct] : []), has = cart.items.some(function (it) { return fps.indexOf(it.product_id) > -1; }) || cart.total_weight >= 100; /* = Shopify Free Shipping ≥100 g (2+2, 3+3), 2026-11-03 */ left = has ? 0 : 1; pct = has ? 100 : Math.min(95, Math.round(cart.total_price / (cart.total_price + (cfg.gap || 700)) * 100)); label = '<b>' + money(cfg.gap || 700) + '</b>'; }
      else if (cfg.mode === 'items') { var need = cfg.need || 2; left = Math.max(0, need - count); pct = Math.min(100, Math.round(count / need * 100)); label = '<b>' + (cfg.gap ? money(cfg.gap) : left) + '</b>'; }
      else { left = Math.max(0, th - cart.total_price); pct = Math.min(100, Math.round(cart.total_price / th * 100)); label = '<b>' + money(left) + '</b>'; }
      $('[data-vp-progress-bar]', drawer).style.width = pct + '%';
      $('[data-vp-progress-text]', drawer).innerHTML = left > 0 ? cfg.t.left.replace('{amount}', label).replace('{count}', label) : cfg.t.done;
      drawer.classList.toggle('is-free', left <= 0);
      // Dovanų etapai
      $$('[data-vp-gift-tier]', drawer).forEach(function (g) { g.classList.toggle('is-on', maxTier >= parseInt(g.getAttribute('data-vp-gift-tier'), 10)); });
      // Upgrade
      var up = $('[data-vp-upgrade]', drawer);
      if (up) {
        var lowItem = null; cart.items.forEach(function (it) { var t = tiers[String(it.variant_id)] || 0; if (t > 0 && t * it.quantity < 3) lowItem = it; });
        // Abo eilutė → keliam į 3 Dosen Abo (planas „6 Monate“ arba pirmas), ne į vienkartinį (2026-10-20)
        var upPlan = null; if (lowItem && lowItem.selling_plan_allocation && cfg.upgrade) { (cfg.upgrade.plans || []).forEach(function (p) { var m = String(p.n).match(/(\d+)\s*(Monat|month)/i); if (m && parseInt(m[1], 10) === 6) upPlan = p; }); upPlan = upPlan || (cfg.upgrade.plans || [])[0] || null; if (!upPlan) lowItem = null; }
        if (lowItem && cfg.upgrade && cfg.t && cfg.t.upgrade) {
          var diff = (upPlan ? upPlan.p : cfg.upgrade.price) - lowItem.final_line_price;  // visa eilutė keičiama į 1× 3 Dosen (2026-10-20: buvo / quantity → 2× 1 Dose rodė 54,90 vietoj 19,95)
          $('[data-vp-upgrade-text]', up).innerHTML = cfg.t.upgrade.replace('{diff}', '<b>' + money(diff) + '</b>');
          up.hidden = false;
          up.querySelector('button').onclick = function () {
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lowItem.key, quantity: 0 }) })
              .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [upPlan ? { id: cfg.upgrade.id, quantity: 1, selling_plan: upPlan.id } : { id: cfg.upgrade.id, quantity: 1 }] }) }); })
              .then(VPCart.refresh);
          };
        } else up.hidden = true;
      }
      // Papildomas produktas (upsell)
      $$('[data-vp-xsell]', drawer).forEach(function (xs) {
        var xid = parseInt(xs.getAttribute('data-variant'), 10);
        var inCart = cart.items.some(function (it) { return it.variant_id === xid; });
        xs.hidden = count === 0 || inCart;
      });
      var protRow = $('[data-vb-prot]', drawer);
      if (protRow) {
        var protT = $('[data-vb-prot-toggle]', protRow), protP = $('[data-vb-prot-price]', protRow);
        protRow.hidden = !prot || count === 0;
        if (prot) { protT.checked = protQty > 0; protRow.classList.toggle('is-on', protQty > 0); if (protP) protP.textContent = money(prot.price); }
      }
      $('[data-vp-subtotal]', drawer).textContent = money(cart.total_price);
      var was = $('[data-vp-subtotal-was]', drawer), sv = $('[data-vp-save]', drawer), diffT = wasTotal - cart.total_price;
      if (was) was.textContent = diffT > 0 ? money(wasTotal) : '';
      if (sv) sv.textContent = diffT > 0 ? (cfg.t.saved || 'You save') + ' ' + money(diffT) : '';
    }
  };
  VPCart.quiet = vpQuiet; /* vb-give 2026-10-31: auka be AddToCart */
  window.VPCart = VPCart;
  /* vb-protect: pirkėjo išjungimas galioja šiam krepšeliui (cart.token); naujas krepšelis — vėl įjungta */
  VPCart.protOff = function (cart) { var t = String((cart && cart.token) || ''), v = VPCart._protOff || ''; try { v = localStorage.getItem('vbProtOff') || v; } catch (e) {} return !!t && v === t; };
  if (drawer && ((CFG.gifts || []).length || CFG.protect) && /(^|;\s*)cart=/.test(document.cookie)) VPCart.refresh();
  if (drawer) {
    $$('[data-vp-xsell-add]', drawer).forEach(function (xsb) { xsb.addEventListener('click', function () {
      var xs = xsb.closest('[data-vp-xsell]'); xsb.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(xs.getAttribute('data-variant'), 10), quantity: 1 }] }) })
        .then(function () { xsb.removeAttribute('aria-busy'); return VPCart.refresh(); });
    }); });
    var protSw = $('[data-vb-prot-toggle]', drawer);
    if (protSw) protSw.addEventListener('change', function () {
      var c = VPCart._cart, p = VPCart.data.protect, on = protSw.checked, JH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      if (!c || !p) return;
      var tok = on ? '' : String(c.token || ''), upd = {};
      VPCart._protOff = tok; try { if (tok) localStorage.setItem('vbProtOff', tok); else localStorage.removeItem('vbProtOff'); } catch (e) {}
      c.items.forEach(function (it) { if (it.variant_id === p.v) upd[it.key] = 0; });
      protSw.disabled = true; drawer.classList.add('is-busy');
      (on ? vpQuiet('/cart/add.js', { method: 'POST', headers: JH, body: JSON.stringify({ items: [{ id: p.v, quantity: 1 }] }) })
          : vpQuiet('/cart/update.js', { method: 'POST', headers: JH, body: JSON.stringify({ updates: upd }) }))
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c2) { protSw.disabled = false; drawer.classList.remove('is-busy'); VPCart.render(c2); }, function () { protSw.disabled = false; drawer.classList.remove('is-busy'); VPCart.refresh(); });
    });
    $$('[data-vp-cart-close]', drawer).forEach(function (b) { b.addEventListener('click', VPCart.close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) VPCart.close(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="/cart"], [data-vp-cart-open]');
      if (a && !e.defaultPrevented && !document.querySelector('[data-template="cart"]')) { e.preventDefault(); VPCart.open(); }
    });
  }
})();
/* 2026-10-21 paketų plytelės A: paspaudus „+N Geschenke“ plytelėje — paketas pasirenkamas (label) ir puslapis nuslenka iki dovanų bloko, atsidariusios dovanos sumirksi */
(function () {
  document.addEventListener('click', function (e) {
    var g = e.target.closest && e.target.closest('.vpo-tgifts');
    if (!g) return;
    var offer = g.closest('.vpo'), box = offer && offer.querySelector('.vpo-gifts');
    if (!box) return;
    setTimeout(function () {
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
      [].forEach.call(box.querySelectorAll('.vpo-g'), function (c) {
        var on = c.querySelector('.vpo-on');
        if (on && on.offsetParent !== null) { c.classList.remove('is-flash'); void c.offsetWidth; c.classList.add('is-flash'); }
      });
    }, 80);
  });
})();
/* 2026-10-21 Abo eilutė krepšelyje: krepšelio eilutėje vietoj „Alle 4 Monate“ — paryškinta „↻ Spar-Abo · alle 4 Monate“ (žodis — sekcijos nustatymas t.abo) */
if (window.VPCart) window.VPCart.subLine = function (name, cfg) {
  var abo = (cfg && cfg.t && cfg.t.abo) || 'Subscribe & save';
  var plan = /abo/i.test(name) ? name : abo + ' · ' + name.charAt(0).toLowerCase() + name.slice(1);
  return '<span class="vpc-sub"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 0 0-14.3-4.9L4 8"/><path d="M4 4v4h4"/><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16"/><path d="M20 20v-4h-4"/></svg>' + plan + '</span>';
};
/* 2026-10-21 juostos rodyklė aukštyn: rodyklė virš lipnios juostos → atgal prie paketų */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vp-sticky-up]');
    if (!b) return;
    var offer = b.closest('[data-vp-offer]') || document;
    var el = offer.querySelector('.vpo-promo') || offer.querySelector('.vpo-tiles-hd') || offer.querySelector('.vpo-tiles');
    if (!el) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 12, behavior: calm ? 'auto' : 'smooth' });
    setTimeout(function () {
      var t = offer.querySelector('.vpo-tile input:checked');
      t = t && t.closest('.vpo-tile');
      if (t) { t.classList.remove('is-flash'); void t.offsetWidth; t.classList.add('is-flash'); }
    }, 650);
  });
})();
